import { render } from "./TemplateMfittMyTicketRefund.vue?vue&type=template&id=27e945bb"
import script from "./TemplateMfittMyTicketRefund.vue?vue&type=script&lang=js"
export * from "./TemplateMfittMyTicketRefund.vue?vue&type=script&lang=js"

import "./TemplateMfittMyTicketRefund.vue?vue&type=style&index=0&id=27e945bb&lang=css"
script.render = render

export default script